import React from "react";
import classes from "./Services.module.css";

const Fascial = () => {
  return (
    <div className={classes.Intro}>
      <h1 className={classes.focusLine}>
        <span>Fascial Stretch Therapy</span>
      </h1>
      <div className={classes.container1}>
        <p>
          Fascia is your connective tissue, which is the most influential
          structure in your body affecting your flexibility. Fascia covers your
          joints, ligaments, tendons, muscles and bones. Age, trauma, injuries,
          poor posture and inadequate training can distort, twist and tighten
          the fascia. This can cause pain and discomfort in joints, muscles,
          tendons, ligaments and discs.
        </p>
        <p>
          Fascial Stretch Therapy™ (FST) is a proven system of pain-free,
          table based assisted stretching that helps you rapidly gain new ranges
          of motion, reduce chronic pain, manage stress and move freely. This
          enables you to return to the activities you enjoy like golfing,
          tennis, and downhill skiing.:
        </p>
        <p>
          During each session your FST provider will evaluate where lines of
          movement restriction are and stretch you in ways that you are unable
          to on your own. After your first FST session you will feel lighter,
          more relaxed and rebalanced. Your body will feel more open and less
          compressed. This feeling lasts several days. It takes 3-6 sessions to
          see longer lasting effects.
        </p>
        <p>
          Everyone – from those with chronic diseases to elite athletes – can
          benefit from FST.
        </p>
      </div>
    </div>
  );
};

export default Fascial;
